import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Paper,
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
const BinSingleForm = ({ action, props, text, link }) => {
  const user = useSelector((state) => getUser(state));
  const { t } = useTranslation();
  const handleSubmit = (id) => {
    action(id);
  };

  return (
    <>
      {props.length > 0 && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 250 }} size="small" aria-label="a danse table">
            <TableHead>
              <TableRow>
                <TableCell>{text}</TableCell>
                {user.users.role === 'ADMIN' && (
                  <TableCell> {t('bins.warehouse')}</TableCell>
                )}
                <TableCell align="center">{t('account.action')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.map((bin) => (
                <TableRow
                  key={bin.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th">{bin.binName}</TableCell>
                  {user.users.role === 'ADMIN' && (
                    <TableCell>{bin.warehouse}</TableCell>
                  )}
                  <TableCell align="center">
                    <Button
                      sx={{ color: 'orange' }}
                      component={Link}
                      to={`/${link}/${bin.id}`}
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      sx={{ color: 'red' }}
                      onClick={() => handleSubmit(bin.id)}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default BinSingleForm;
